export const DEFAULT_TIMEZONE = 'America/New_York'
export const DEFAULT_DATE_TIME_FORMAT = 'MMM Do YYYY h:mm:ss a'